import { render } from "./HistorialTurno.vue?vue&type=template&id=8beda57e"
import script from "./HistorialTurno.vue?vue&type=script&lang=js"
export * from "./HistorialTurno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__